<script lang="ts">
	import type { Component } from 'svelte'
	import type { HTMLButtonAttributes } from 'svelte/elements'

	interface Props extends HTMLButtonAttributes {
		// text shown next to the icon
		label: string
		// icon component rendered before the label (e.g. an imported `*.svg?component`)
		icon?: Component
		// rendered size of the icon in px
		iconSize?: number
	}

	let { label, icon: Icon, iconSize = 20, ...rest }: Props = $props()
</script>

<button type="button" class="menu-chip" {...rest}>
	{#if Icon}
		<Icon
			class="menu-chip__icon"
			width={iconSize}
			height={iconSize}
			aria-hidden="true"
			fill="inherit"
		/>
	{/if}
	<span class="menu-chip__label">{label}</span>
</button>

<style lang="scss">
	.menu-chip {
		display: inline-flex;
		align-items: center;
		gap: 7px;
		padding: 0 8px;
		background-color: var(--color-blueish-100, #f0f3f4);
		border: 0;
		border-radius: 50px;
		color: #000;
		cursor: pointer;
		min-height: 36px; /* for now, this fixes the height of the button, later, we should remove this when we have a new top bar */

		&__icon {
			flex-shrink: 0;
		}

		&__label {
			font-size: 0.75rem;
			line-height: 18px;
			font-weight: 500;
			color: black;
			white-space: nowrap;
			transition: color 0.15s ease-in-out;
		}

		// Only the label turns green on hover. The icon uses `currentColor`
		// inherited from the chip's (unchanged) color, so it keeps its color.
		&:hover &__label,
		&:focus-visible &__label {
			color: var(--color-green-500, #58c079);
		}
	}
</style>
